import React from "react";
import { OfficeFilterDropdown } from "@/ui/_to_replace/OfficeFilterDropdown";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { CampusIcon } from "@cmp-src/icons/icons";

interface ReserveFormOfficeSelectorProps {
  className?: string;
}

export const ReserveFormOfficeSelector = ({
  className
}: ReserveFormOfficeSelectorProps) => {
  const {
    resource,
    selectedOffice,
    offices,
    setSelectedOffice,
    currentOffice,
    setFilterFloor
  } = useReserveForm();

  return (
    <OfficeFilterDropdown
      className={className ?? "grow"}
      readonly={!!resource}
      setOfficeId={(id) => {
        const office = offices.find((x) => x.id === id) ?? currentOffice;
        setSelectedOffice(office);
        setFilterFloor(null);
      }}
      officeId={selectedOffice?.id ?? null}
      offices={offices}
      customIcon={<CampusIcon className="h-4 w-4 opacity-50" />}
    />
  );
};
